angular.module('content.widgets.sbarWidget', [
  'content.widgets.SbarWidgetController'
])

/**
 * The componentSbarWidget provides a preview
 * of the sbarWidget item type
 *
 * @class SbarWidget
 * @constructor
 * @module content.widgets.sbarWidget
 * @example
 *   <sbar-widget
 *     model="form.model">
 *   </sbar-widget>
 */
.directive('sbarWidget', [
  '$state',
  function ($state) {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        if ($state.params.widgetMode === 'edit' || $state.params.stateMode === 'edit') {
          return 'content/source/content/widgets/sbarWidget/sbar-widget-edit.html';
        }
        return 'content/source/content/widgets/sbarWidget/sbar-widget.html';
      },
      controller: 'SbarWidgetController'
    };
  }
]);
